import { useEffect, type ReactElement } from "react";
import { Tooltip } from "@/components/ui/tooltip/Tooltip";
import type { EntityRef } from "../shared/entityDeepLink";
import { EntityPreview } from "./EntityPreview";
import { prefetchEntityPreview } from "./entityPreviewData";

export interface EntityPreviewBubbleProps {
  entity: EntityRef;
  children: ReactElement;
  placement?: "top" | "bottom" | "left" | "right";
}

/**
 * Hover bubble showing a full-fidelity, pre-rendered preview of `entity`.
 * Data is warmed on mount so the hover render is instant; the bubble is
 * interactive (you can move into it) via the underlying `Tooltip`.
 */
export function EntityPreviewBubble({
  entity,
  children,
  placement = "left",
}: EntityPreviewBubbleProps) {
  useEffect(() => {
    prefetchEntityPreview(entity);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [entity.kind, entity.id, entity.version]);

  return (
    <Tooltip
      placement={placement}
      maxWidth="min(30rem, 92vw)"
      delay={250}
      content={
        <div className="w-[28rem] max-w-[92vw] max-h-[32rem] overflow-auto">
          <EntityPreview entity={entity} />
        </div>
      }
    >
      {children}
    </Tooltip>
  );
}
